module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAA3ElEQVRYR+2YvQ3CQAyFn50axBIIRoAeFqBIk0UQAyAWSYIiwQLQwwqIJfhrY6NLQ4GQG5Rc4SvvFffu81eZACDP82HCvAEwA9APdy2eB4BjLbLMsuxKVVWNROQM1UGLJb6fIrox84S2ZbkDsOi0zOfxfSh072BMv/7/CoU0EjpNDS9kTcMJOSGLgJW7Q07IImDl7pATsghYuTvkhCwCVu4OOSGLgJW7Q07IImDlUToU3bIhrnVMURRjZj7FsLASkSkFyZotWl2voToHUc8S76+56hNEB06SVZqmlzeBroxIzijllgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/tag/Check box_icon_nor@2x.png
// module id = 6a/L
// module chunks = 1